<template>
  <div id="lm-breadcrumb" class="d-none d-xl-flex">
    <b-breadcrumb :items="items"/>
  </div>
</template>

<script>
export default {
  data () {
    return {
      items: []
    }
  },
  watch: {
    '$route.path' () {
      this.setBreadcrumb()
    }
  },
  methods: {
    setBreadcrumb () {
      this.items = this.$route.matched.map(el => {
        return {
          text: el.meta.breadcrumb.name,
          to: el.meta.breadcrumb.to
        }
      })
    }
  },
  created () {
    this.setBreadcrumb()
  }
}
</script>

<style lang="sass" scoped>
  .breadcrumb-item
    & + .breadcrumb-item
      &::before
        display: inline-block
        padding-right: 0.5rem
        color: $primaryFontThemeColor
        content: "\F0142"
        font-family: "Material Design Icons"
    &.active
      color: #adb5bd
    a[href^="#"]
      cursor: default
      &:hover
        color: $primaryThemeColor
</style>
